import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/ai-society")({
  head: () => ({
    meta: [
      { title: pageTitle("AI & Society", "en") },
      { name: "description", content: "Essays on artificial intelligence, ethics, trust and the systems reshaping our societies." },
      { property: "og:title", content: "AI & Society — Smart Sustainability" },
      { property: "og:description", content: "Essays on AI, ethics and society." },
      { property: "og:url", content: "https://smartsustainability.ai/ai-society" },
      { property: "og:locale", content: "en_US" },
      { property: "og:locale:alternate", content: "tr_TR" },
    ],
    links: [
      { rel: "canonical", href: "https://smartsustainability.ai/ai-society" },
      ...hreflangLinks("/yapay-zeka-toplum", "/ai-society"),
    ],
  }),
  loader: () => getAllPosts(),
  component: AiSocietyPage,
});

function AiSocietyPage() {
  const { t } = useT();
  const { articles: posts } = useLocalizedPosts(Route.useLoaderData());
  return (
    <CategoryPage
      category={t("cat.ai.title")}
      tagline={t("cat.ai.tagline")}
      essays={posts.filter((p) => String(p.category) === "AI & Society" || String(p.category) === "Yapay Zekâ & Toplum")}
    />
  );
}
